export function disableDangerousAPIs() {
  if (navigator.mediaDevices?.getUserMedia) {
    navigator.mediaDevices.getUserMedia = () =>
      Promise.reject(new Error("Camera/microphone access is disabled by policy."));
  }

  if (navigator.geolocation) {
    navigator.geolocation.getCurrentPosition = (_success, error) => {
      error?.(new GeolocationPositionError());
    };
    navigator.geolocation.watchPosition = (_success, error) => {
      error?.(new GeolocationPositionError());
      return 0;
    };
  }
}
